import * as preact from "preact";
import { BaseComponent, IBaseComponentProps } from "../BaseComponent/BaseComponent";

export interface IRenderInBodyProps extends IBaseComponentProps
{
    children;
}

export class RenderInBody extends BaseComponent<IRenderInBodyProps>
{
    constructor(props)
    {
        super(props)
    }

    public override componentDidMount(): void
    {
        super.componentDidMount();
        document.body.appendChild(this.Container);
    }

    public render()
    {
        // Render a placeholder
        return (<div ref={(ref) => this._registerContainer(ref)}>{this.props.children}</div>);
    }
}
